<fa-icon
  kendoPopoverAnchor
  [popover]="discountPopover"
  [showOn]="'hover'"
  class="info"
  [icon]="['fas', 'circle-info']"
></fa-icon>

<kendo-popover #discountPopover>
  <ng-template kendoPopoverTitleTemplate> Whopper Combo (Small) </ng-template>
  <ng-template kendoPopoverBodyTemplate>
    <kendo-gridlayout [gap]="{ rows: 6, cols: 2 }">
      <kendo-gridlayout-item [row]="1" [col]="1"
        >Whopper ALC</kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="1" [col]="2">$5.89</kendo-gridlayout-item>

      <kendo-gridlayout-item [row]="2" [col]="1"
        >Combo Markup</kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="2" [col]="2">$3.40</kendo-gridlayout-item>

      <kendo-gridlayout-item [row]="3" [col]="1"
        ><span class="bold-text">Combo Price</span></kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="3" [col]="2"
        ><span class="bold-text">$9.29</span></kendo-gridlayout-item
      >
    </kendo-gridlayout>
  </ng-template>
  <ng-template kendoPopoverActionsTemplate>
    <p class="xsmall-text subtle-text">
      Sample data provided for demonstration purposes
    </p>
  </ng-template>
</kendo-popover>
